export default function StatsSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="w-full lg:w-7/12">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-8">
              Why OOPBuy<br />
              Spreadsheet<br />
              Works for You
            </h2>

            <div className="grid grid-cols-3 gap-6">
              <div className="relative">
                <div className="text-5xl md:text-6xl font-extrabold text-primary-500 mb-2">
                  14K+
                </div>
                <p className="text-sm text-foreground-600 leading-snug">
                  Products Listed
                </p>
                <div className="absolute right-0 top-1/2 -translate-y-1/2 h-12 w-px bg-background-300 hidden sm:block"></div>
              </div>

              <div className="relative">
                <div className="text-5xl md:text-6xl font-extrabold text-accent-500 mb-2">
                  14
                </div>
                <p className="text-sm text-foreground-600 leading-snug">
                  Categories Covered
                </p>
                <div className="absolute right-0 top-1/2 -translate-y-1/2 h-12 w-px bg-background-300 hidden sm:block"></div>
              </div>

              <div>
                <div className="text-5xl md:text-6xl font-extrabold text-secondary-500 mb-2">
                  100%
                </div>
                <p className="text-sm text-foreground-600 leading-snug">
                  Verified Links
                </p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-5/12">
            <div className="relative w-full aspect-square max-w-[420px] mx-auto rounded-2xl overflow-hidden bg-gradient-to-br from-primary-100/60 via-accent-100/40 to-secondary-100/50">
              <div className="absolute top-8 right-6 w-32 h-20 rounded-2xl bg-primary-200/60 rotate-12"></div>
              <div className="absolute bottom-16 left-4 w-24 h-28 rounded-3xl bg-accent-200/50 -rotate-6"></div>
              <div className="absolute top-24 left-8 w-20 h-20 rounded-full bg-secondary-200/60"></div>
              <div className="absolute bottom-8 right-10 w-28 h-16 rounded-xl bg-primary-100/70 rotate-[-15deg]"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-36 h-36 rounded-full bg-accent-100/40"></div>
              <div className="absolute bottom-32 right-20 w-14 h-14 rounded-lg bg-secondary-100/60 rotate-45"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}